


















import {Component, Prop, Vue} from "vue-property-decorator"
import DataGrid, {DataType} from "@/components/DataGrid.vue"
import {executeQuery} from "@/data/repos/query"
import AppraisalFacetScoresDrillDown2 from "@/components/widgets/appraisal/AppraisalFacetScoresDrillDown2.vue"
import {AppraisalItem, getAppraisalTitlePath} from "@/data/repos/appraisal"
import ModalContainer from "@/components/dialogs/ModalContainer.vue"
import {bus} from "@/main"
import DataGridClick from "@/components/buttons/DataGridClick.vue"

@Component({
  components: {
    ModalContainer,
    DataGrid,
    AppraisalFacetScoresDrillDown2,
  },
})
export default class AppraisalFacetScoresDrillDown extends Vue {
  @Prop() public args!: { locationId: number, risk: AppraisalItem }
  private data: any[] | null = null
  private riskFieldPrefix = "countOfRisk"
  private dataGridFields: any[] | null = null
  public drillDown2Show = false
  public drillDown2Args: { locationId: number, row: any, riskId: number, aprItems: AppraisalItem, scoreId: number } | null = null

  public get title() {
    return "Appraisal facet scores breakdown - " + getAppraisalTitlePath(this.args.risk)
  }

  private linkClickCallback(fieldName: string, row: any): { click: Function, text: string } {
    return {
      click: (fieldName: string, row: any) => {
        const riskId = row[fieldName + "_id"]
        this.drillDown2Args = {locationId: row["buildingId"], row, riskId, aprItems: this.args.risk, scoreId: row[`${fieldName}_id`]}
        this.drillDown2Show = true
      },
      text: row[fieldName],
    }
  }

  public drillDown2Hide() {
    this.drillDown2Show = false
    this.drillDown2Args = null
  }

  public async created() {
    // this.getData()
  }

  public getFields(countOfRiskFields: Map<String, Number>) {
    const riskFields: any = []
    for (const field of [...countOfRiskFields.entries()].sort((a: any, b: any) => b[0] - a[0])) {
      riskFields.push({
        name: field[0],
        title: field[0].substr(this.riskFieldPrefix.length),
        dataType: DataType.Number,
        sort: 1,
        component: DataGridClick,
        callback: this.linkClickCallback,
      })
    }
    const fields = [
      {name: 'regionName', title: 'Region', dataType: DataType.Text, sort: 1},
      {name: 'siteName', title: 'Site', dataType: DataType.Text, sort: 1},
      {name: 'buildingName', title: 'Building', dataType: DataType.Text, sort: 1},
      ...riskFields,
    ]
    this.dataGridFields = fields
    return fields
  }

  public async getData(offset = 0) {
    if (offset) {
      return []
    }
    if (!this.data) {
      const resp = await this.loadData(this.args.locationId, this.args.risk)
      if (resp) {
        this.getFields(resp[1])
        this.data = resp[0]
      }
    }
    return this.data
  }

  private async loadData(locationId: number, aprItem: any): Promise<any[] | null> {
    // console.log("load data", JSON.stringify(risk, null, 1))
    const queryName = aprItem.subelementId ? "appraisal.score.scoreDrillDown_subelement" :
      aprItem.elementId ? "appraisal.score.scoreDrillDown_element" :
        aprItem.categoryId ? "appraisal.score.scoreDrillDown_category" :
          aprItem.facetId ? "appraisal.score.scoreDrillDown_facet" : null
    const args: any = aprItem.subelementId ? {subelementId: aprItem.subelementId} :
      aprItem.elementId ? {elementId: aprItem.elementId} :
        aprItem.categoryId ? {categoryId: aprItem.categoryId} :
          aprItem.facetId ? {facetId: aprItem.facetId} : null
    args.locationId = locationId
    if (queryName) {
      return executeQuery("idr", queryName, args, this.filter)
    }
    return []
  }

  private filter(data: any[]): [any, Map<String, Number>] {
    const riskMap: Map<Number, RiskItem> = new Map<Number, RiskItem>()
    const buildingIdSet: Set<number> = new Set()
    const countOfRiskFields = new Map<String, Number>()
    for (const item of data) {
      const buildingId = item.buildingid
      buildingIdSet.add(buildingId)
      const existingRisk = riskMap.get(buildingId)
      countOfRiskFields.set(this.riskFieldPrefix + item.conditionRating, item.conditionScore)
      if (existingRisk) {
        existingRisk.scoreCountMap.set(item.conditionRating, [item.CountOfRank, item.scoreid])
      } else {
        let scoreCountMap: Map<string, number[]> = new Map([[item.conditionRating, [item.CountOfRank, item.scoreid]]])
        riskMap.set(buildingId, {
          regionName: item.regionname,
          siteName: item.sitename,
          buildingName: item.buildingname,
          buildingId: item.buildingid,
          buildingCode: item.buildingcode,
          scoreCountMap: scoreCountMap,
          riskLabel: item.conditionRating,
        } as RiskItem)
      }
    }
    const riskItems: RiskItem[] = []
    for (const buildingId of buildingIdSet.values()) {
      const item = riskMap.get(buildingId)
      if (item) {
        let record: any = {...item}
        for (const score of item.scoreCountMap.entries()) {
          record[this.riskFieldPrefix + score[0]] = score[1][0]
          record[this.riskFieldPrefix + score[0] + "_id"] = score[1][1]
        }
        delete record.riskCountMap
        riskItems.push(record)
      }
    }
    return [riskItems, countOfRiskFields]
  }

  public close() {
    bus.$emit("modalBoxDestroy")
  }

  public download() {
    const fileDownload = require('js-file-download')
    fileDownload(JSON.stringify(this.data), "appraisal-facet-scores.json")
  }
}

interface RiskItem {
  regionName: string,
  siteName: string,
  buildingName: string,
  buildingId: number,
  riskLabel: string,
  buildingCode: string,
  riskIDs: Map<string, number>,
  scoreCountMap: Map<string, number[]>,
}

